import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { helper } from 'src/environments/helper';
import { IProiect } from '../../proiecte.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { CommonService } from 'src/app/services/common.service';
import { ProiecteService } from '../../proiecte.service';
import { IFurnizorForm, IFurnizorUpdatePayload } from './update-furnizor-proiect.interface';

@Component({
    selector: 'app-update-furnizor-proiect',
    templateUrl: './update-furnizor-proiect.component.html',
    styleUrls: ['./update-furnizor-proiect.component.scss']
})
export class UpdateFurnizorProiectComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    passedProiectId!: number;
    furnizoriActive$!: Observable<Generic[]>;

    defaultParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    provider_type: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Firmă', value: 1 },
        { key: 'Instituție Publică (Regie Propie)', value: 2 },
        { key: 'Firmă și Instituție Publică', value: 3 },
    ];

    form: FormGroup = new FormGroup({
        provider_type: new FormControl(this.data.proiect.provider.provider_type, [Validators.required, Validators.min(0)]),
        provider: new FormControl(this.data.proiect.provider.id, [Validators.required, Validators.min(0)]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            proiect: IProiect,
        },
        private dialogRef: MatDialogRef<UpdateFurnizorProiectComponent>,
        private notificationService: NotificationService,
        private commonService: CommonService,
        private proiecteService: ProiecteService,
    ) { }

    ngOnInit(): void {
        this.passedProiectId = this.data.proiect.id_proiect;

        this.loadFurnizoriActive(this.data.proiect.provider.provider_type);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { provider } = this.form.value as IFurnizorForm;
        const payload: IFurnizorUpdatePayload = {
            provider,
        };

        this.proiecteService
            .updateFurnizor(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onTipFurnizoriChange(provider_type: number): void {
        if (provider_type > 0) {
            this.loadFurnizoriActive(provider_type);
        } else {
            this.furnizoriActive$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: '--Alegeți--', id: -1 }]);
                observer.complete();
            });
        }
    }

    loadFurnizoriActive(provider_type?: number) {
        this.isLoading = true;
        let furnizoriObservable$ = provider_type ?
            this.commonService.filterProviderProiecte(provider_type) :
            this.commonService.getProviderProiecte()

        this.furnizoriActive$ = furnizoriObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isLoading = false;
            })
        );
    }
}
